import { BriefcaseBusiness, FolderTree, Target, Users } from "lucide-react";
import { CAMPAIGN_STATUSES } from "../types/campaign-status.constants";

export const statusBadgeClassNames: Record<CAMPAIGN_STATUSES, string> = {
  active: "border-emerald-200 bg-emerald-50 text-emerald-700",
  unactive: "border-slate-200 bg-slate-100 text-slate-700",
};

export const statIconClassName =
  "w-8 h-8 rounded-lg flex items-center justify-center bg-[#F2FCFA] text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400";

export const campaignStatIcons = {
  residentsEngaged: (
    <div className={statIconClassName}>
      <Users className="h-4 w-4" />
    </div>
  ),
  activeCampaignCount: (
    <div className={statIconClassName}>
      <FolderTree className="h-4 w-4" />
    </div>
  ),
  communityPartnerCount: (
    <div className={statIconClassName}>
      <BriefcaseBusiness className="h-4 w-4" />
    </div>
  ),
  opportunitiesCompletedCount: (
    <div className={statIconClassName}>
      <Target className="h-4 w-4" />
    </div>
  ),
};
